import styled from 'styled-components';

import Icon from '@/atoms/Icon/Icon';
import {sizePx} from '@/theme/helpers/size';

export const StyledChevronRightIcon = styled(Icon)`
  margin-left: ${sizePx(4)};
  margin-bottom: ${sizePx(1)};
`;
